import React from 'react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { ArrowLeft, Layers } from 'lucide-react';
import { useTerms, getTerm } from '@/lib/branding';

export function ModelPicker({ models, onSelectModel, onBack }) {
  useTerms();
  const term = getTerm('insights', 'singular');
  return (
    <div className="p-6 pt-4" data-testid="model-picker">
      <div className="max-w-3xl mx-auto">
        <div className="flex items-center gap-2 mb-6">
          <Button variant="ghost" size="icon" onClick={onBack} className="rounded-lg w-8 h-8"><ArrowLeft className="w-4 h-4" /></Button>
          <div>
            <h1 className="text-2xl font-heading font-bold text-foreground">New {term}</h1>
            <p className="text-sm text-muted-foreground">Choose the semantic model this {getTerm('insights', 'singular', 'lower')} will be built against</p>
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pb-6" data-testid="model-picker-grid" data-coach-target="model-picker">
          {models.map(m => (
            <button key={m.model_id} onClick={() => onSelectModel(m.model_id)}
              className="glass-card rounded-2xl p-5 text-left hover:border-primary/30 hover:shadow-[0_0_20px_rgba(59,130,246,0.15)] transition-all active:scale-[0.98] group"
              data-testid={`pick-model-${m.model_id}`}>
              <div className="flex items-start gap-3">
                <div className="p-2.5 rounded-xl bg-indigo-500/10 border border-indigo-500/20 group-hover:bg-indigo-500/20 transition-colors flex-shrink-0">
                  <Layers className="w-6 h-6 text-indigo-400" strokeWidth={1.5} />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-heading font-semibold text-foreground">{m.name}</h3>
                  <p className="text-xs text-muted-foreground mt-0.5 line-clamp-2">{m.description}</p>
                  <div className="flex items-center gap-2 mt-2">
                    <Badge className={`text-[9px] ${m.status === 'published' ? 'bg-emerald-500/15 text-emerald-400 border-emerald-500/20' : 'bg-amber-500/15 text-amber-400 border-amber-500/20'}`}>{m.status}</Badge>
                    <span className="text-[10px] text-muted-foreground">v{m.version}</span>
                  </div>
                </div>
              </div>
            </button>
          ))}
          {models.length === 0 && (
            <div className="glass-card rounded-2xl p-8 text-center col-span-full">
              <p className="text-sm text-muted-foreground">No semantic models available. Create one first.</p>
              <Button onClick={onBack} variant="outline" className="mt-3 rounded-lg text-xs">Go to Semantic Models</Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
